import React, { useEffect } from 'react';
import {GET_PROPERTY_URL} from '../../../api';
import {getPropertyStatistics, deactivateProperty, deleteProperty} from '../../../request/users';
import 'datatables.net';
import 'datatables.net-responsive';
import {Link} from "react-router-dom";
import $ from "jquery";
import cogoToast from "cogo-toast";
import {encodeQueryParameter} from "../../../utils/url";

const Property = () => {

    document.title = "Property";

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        getPropertyStatistics().then((response) => {
            $('#total-property').text(response.total);
            $('#total-vacant').text(response.vacant);
            $('#total-occupied').text(response.occupied);
        });

        var table = $('#property').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting User Report</p>'
            },
            "searching": true,
            "lengthMenu": [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_PROPERTY_URL, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: res.data
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/edit-property/${encodeQueryParameter(data)}" class="nav-link">${data.name}</a></nav>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.location.area;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `${data.price.currency} ${data.price.tag} (${data.category.name})`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `${data.status === "vacant" ? '<span class="badge badge-success">Vacant</span>' : '<span class="badge badge-danger">Occupied</span>'}`;
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link"><i class="fa fa-arrow-up"></i> Priorties</a> ${data.status === "vacant" ? '<a href="#" class="nav-link deactivate_property"><i class="fa fa-eye-slash"></i> Deactivate</a>' : '<a href="#" class="nav-link deactivate_property"><i class="fa fa-eye"></i> Activate</a>'} <a href="#" class="nav-link delete_property"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        $('#property').on('click', '.deactivate_property', function() {
            let extract_td = table.row($(this).closest('tr')).data();

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            deactivateProperty(extract_td.raw._id).then((result) => {
                hide();

                if(result.error === false) {
                    $('#property').DataTable().ajax.reload(null, false);
                }
            });

            return false;
        });

        $('#property').on('click', '.delete_property', function() {
            let extract_td = table.row($(this).closest('tr')).data();

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            deleteProperty(extract_td.raw._id).then((result) => {
                hide();

                if(result.error === false) {
                    $('#property').DataTable().ajax.reload(null, false);
                }
            });

            return false;
        });
    }, []);

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Property</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Property</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <Link to="/create-property" className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none"><i className="wd-10 mg-r-5 fa fa-plus"></i> Add New</Link>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-4">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Property</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-property" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">-</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Vacant Property</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-vacant" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Occupied Property</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-occupied" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Total Users</h6>
                                <div className="d-flex tx-18">
                                    <a href="" className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="property" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Location</th>
                                        <th className="wd-20p">Price</th>
                                        <th className="wd-15p">Status</th>
                                        <th className="wd-25p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                                <div className="modal fade" id="my_modal" tabIndex="-1" role="dialog" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <div className="media align-items-center">
                                                    <div className="media-body">
                                                        <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </a>
                                                        <p className="tx-13 tx-color-02 mg-b-0 tx-semibold" id="title">Error</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-body">
                                                <table id="geography" className="table tx-13 mg-b-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Age Group</th>
                                                        <th>Male</th>
                                                        <th className="text-right">Female</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>18 - 24</td>
                                                        <td id="mag1">0</td>
                                                        <td id="fag1" className="text-right">0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25 - 34</td>
                                                        <td id="mag2">0</td>
                                                        <td id="fag2" className="text-right">0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35 - 44</td>
                                                        <td id="mag3">0</td>
                                                        <td id="fag3" className="text-right">0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45 and above</td>
                                                        <td id="mag4">0</td>
                                                        <td id="fag4" className="text-right">0</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Property;
